import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  invitationURl: any;
  baseURL = environment.AuthURL;
  baseURL1 = environment.AuthURL;
  companyList: any;

  constructor(
    private http : HttpClient,
    private toastrService: ToastrService,
    private router: Router
  ) { }
 
  loginUser(userDetails) {
    //
    return this.http.post(`${this.baseURL1}/api/auth/login`, userDetails);
  }
  // new api
  loginUser2(userDetails) {
   
    //
    return this.http.post(`${this.baseURL1}/api/auth/login`, userDetails);
  }
  getToken(){
    return sessionStorage.getItem('token')
  }
  getAllNotification(){
    return this.http.get(`${this.baseURL1}/api/auth/getAllNotification`);
  }

  forgotPassword(data) {

    return this.http.post(`${this.baseURL}/api/auth/forgot-password`, data);
  }

  passwordReset(data) {
   
        return this.http.post(`${this.baseURL}/api/auth/password-reset`, data);
      }
  // ToastrService-----------------------------------------------------------------------------
  showToaster(message) {
    this.toastrService.success(message);
  }
  ErrorSuccess(message) {
    this.toastrService.error(message);
  }
  infoSuccess(message) {
    this.toastrService.info(message);
  }
  warningSuccess(message) {
    this.toastrService.warning(message);
  }

}
